<template>
  <div>
    <div class="footer">
      <div class="footer-center">
        <ul>
          <li v-for="(item, i) in bottomList" :key="i" @click="jump(item)">
            {{ item.title }}
          </li>
        </ul>
        <div class="icon">
          <div class="icon-box">
            <img src="@/assets/img/app.png" alt />
            <div class="icon-box-s">
              <div>
                <img src="@/assets/img/code_app.png" alt />
              </div>
              <p>下载app</p>
            </div>
          </div>
          <div class="icon-box">
            <img src="@/assets/img/wechart.png" alt />
            <div class="icon-box-s">
              <div>
                <img src="@/assets/img/code_weixin.png" alt />
              </div>
              <p>微信扫一扫</p>
              <p>关注我们的微信</p>
            </div>
          </div>
          <div class="icon-box">
            <img src="@/assets/img/weibo.png" alt />
            <div class="icon-box-s">
              <div>
                <img src="@/assets/img/code_weibo.png" alt />
              </div>
              <p>微博扫一扫</p>
              <p>关注我们的微博</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="company">
      <div class="company-center">
        <div class="security">
          <div>
            <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">沪ICP备11023243号-5</a>
          </div>
          <div>
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010602000186" target="_blank">沪公网安备 31010602000186号</a>
          </div>
          <div>
            <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">互联网新闻许可证编号 31120180001</a>
          </div>
        </div>
        <div>2021上海第一财经传媒有限公司</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      bottomList: [
        { title: "关于我们", path: "/about" },
        { title: "联系我们", path: "/contact" },
        { title: "用户协议", path: "/agreement" },
        { title: "版权说明", path: "/copyright" },
        { title: "广告", path: "/ad" },
        { title: "招聘", path: "/recruit" },
      ],
    };
  },
  methods: {
    jump(item) {
      this.$router.push({ path: item.path });
    },
  },
};
</script>
<style lang="scss" scoped>
.footer {
  background: #ffffff;
  .footer-center {
    // width: 79%;
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    ul {
      font-size: 14px;
      color: #000000;
      height: 86px;
      align-items: center;
      display: inline-flex;
      white-space: pre;
      li {
        margin-right: 60px;
        cursor: pointer;
      }
    }
    .icon {
      display: flex;
      .icon-box {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: #f5f5f5;
        text-align: center;
        line-height: 52px;
        margin-left: 35px;
        cursor: pointer;
        position: relative;
        .icon-box-s {
          position: absolute;
          background: #fff;
          border: 1px solid #d3d3d3;
          padding: 10px;
          display: none;
          margin-bottom: 20px;
          width: 140px;
          bottom: 100%;
          left: 50%;
          transform: translate(-50%, 0px);
          img {
            width: 100%;
            height: 100%;
          }
          div {
            height: 140px;
            margin-bottom: 10px;
          }
          p {
            line-height: 20px;
          }
        }
      }
      .icon-box:hover .icon-box-s {
        display: block;
      }
    }
  }
}
.company {
  background: #000000;
  height: 50px;
  line-height: 50px;
  white-space: pre;
  padding-bottom: 60px;
  .company-center {
    // width: 79%;
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #ffffff;
    font-size: 14px;
    div {
      display: inline-block;
    }
    .security {
      div {
        margin-right: 60px;
      }
      a {
        color: #fff;
        text-decoration: none;
      }
      a:hover {
        color: #0091ff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue